<template>
  <div :class="$style.videoContent">
    <iframe
      allowfullscreen="true"
      allowtransparency="true"
      :class="['wistia_embed', $style.video]"
      frameborder="0"
      name="wistia_embed"
      :src="videoSrc"
    />
  </div>
</template>

<script>
import Util from 'client/util/Util';

export default {
  name: 'WistiaVideo',

  props: {
    addFullScreenButton: {
      type: Boolean,
      default: true,
    },

    autoPlay: {
      type: Boolean,
      default: false,
    },

    videoUrl: {
      type: String,
      required: true,
    },
  },

  computed: {
    videoSrc() {
      const options = {
        autoPlay: this.autoPlay,
        fullscreenButton: this.addFullScreenButton,
        playerColor: '41c8c3',
      };
      return `${this.videoUrl}?${Util.serialize(options)}`;
    },
  },
};
</script>

<style module>
.videoContent {
  overflow: hidden;
  padding-top: 56.25%; /* This assumes the video has a 16:9 aspect ratio */
  position: relative;
}

.video {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
